import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 51D1A98E-7CD7-4BD7-88C9-333B5435C580
 * name sort-variant-remove
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-variant-remove.svg
 * tags
 * - Text / Content / Format 
 */
export const SortVariantRemoveIcon = createSvgIcon(<><path d="M3 13H15V11H3M3 6V8H21V6M3 18H9V16H3V18M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.46L22.54 16.88" /></>, 'SortVariantRemoveIcon');
export default SortVariantRemoveIcon